import { render, staticRenderFns } from "./UserTaxProfile.vue?vue&type=template&id=cafae00a&"
import script from "./UserTaxProfile.vue?vue&type=script&lang=js&"
export * from "./UserTaxProfile.vue?vue&type=script&lang=js&"
import style0 from "./UserTaxProfile.vue?vue&type=style&index=0&id=cafae00a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports